// Messages for portal/shell/AnnouncementBanners (auto-merged by lib/i18n.ts).
export const en = {
  'portal.announcements.dismiss': 'Dismiss',
}

export const zhTW = {
  'portal.announcements.dismiss': '關閉',
}
